import React, { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUsers,
  FaCalendarAlt,
  FaWallet,
  FaChartBar,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaRegEnvelope,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import logo from "../Images/images/logoblack.png";
import "./footer.css";

const groups = [
  {
    title: "Product",
    links: [
      ["Employee Management", "/employee-management-payroll-software-india"],
      ["Payroll Management", "/best-payroll-management-software-india-2025"],
      [
        "Attendance Management",
        "/best-attendance-management-system-india-2025",
      ],
      ["Expense Management", "/best-expense-management-software-india-2025"],
      [
        "Workspace Management",
        "/best-workspace-management-software-india-2025",
      ],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/About_us"],
      ["Pricing", "/Pricing"],
      ["Careers", "https://enrrol.com/"],
      ["Blog", "/Blogs"],
      ["Contact Us", "/contact_us"],
    ],
  },
  {
    title: "Resources",
    links: [
      ["Task Management", "/best-task-management-software-india-2025"],
      ["Project Management", "/best-project-management-software-india-2025"],
      ["Privacy Policy", "/privacy_policy"],
      ["Terms & Conditions", "/terms_condition"],
      ["Refund & Cancellation", "/refund_policy"],
      ["FAQ", "/faq"],
    ],
  },
];
const highlights = [
  { label: "Manage Employees", icon: FaUsers, color: "blue" },
  { label: "Track Attendance", icon: FaCalendarAlt, color: "green" },
  { label: "Run Payroll", icon: FaWallet, color: "purple" },
  { label: "Get Insights", icon: FaChartBar, color: "orange" },
];
const socials = [
  {
    name: "Instagram",
    icon: FaInstagram,
    url: "https://www.instagram.com/billpunch_official?igsh=M2gwdWVxZG9idnUy",
  },
  {
    name: "Facebook",
    icon: FaFacebookF,
    url: "https://www.facebook.com/profile.php?id=61561070107480",
  },
  {
    name: "LinkedIn",
    icon: FaLinkedinIn,
    url: "https://www.linkedin.com/company/103316744/",
  },
  {
    name: "YouTube",
    icon: FaYoutube,
    url: "https://www.youtube.com/@Billpunch",
  },
];

const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: "instant" });

const FooterPageLink = ({ to, children, ...props }) => (
  <Link
    to={to}
    {...props}
    onClick={(event) => {
      if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        scrollToTop();
      }
    }}
  >
    {children}
  </Link>
);

const Footer = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    if (!window.location.hash) scrollToTop();
  }, [pathname]);

  return (
  <footer className="billpunch-footer">
    <div className="billpunch-footer__inner">
      <div className="billpunch-footer__columns">
        <div className="billpunch-footer__brand">
          <FooterPageLink to="/" aria-label="BillPunch home">
            <img src={logo} alt="BillPunch" />
          </FooterPageLink>
          <h2>All-in-one HRMS for multiple firms.</h2>
          <p>
            Manage your people, attendance, payroll, expenses and workforce
            operations with ease.
          </p>
          <div className="billpunch-footer__highlights">
            {highlights.map(({ label, icon: Icon, color }) => (
              <div key={label}>
                <span
                  className={`billpunch-footer__icon billpunch-footer__icon--${color}`}
                >
                  <Icon aria-hidden="true" />
                </span>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
        {groups.map(({ title, links }) => (
          <nav
            className="billpunch-footer__links"
            key={title}
            aria-label={`Footer ${title.toLowerCase()}`}
          >
            <h2>{title}</h2>
            <ul>
              {links.map(([label, path]) => (
                <li key={label}>
                  {path.startsWith("https:") ? (
                    <a href={path}>{label}</a>
                  ) : (
                    <FooterPageLink to={path}>{label}</FooterPageLink>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ))}
        <div className="billpunch-footer__contact">
          <h2>Get in Touch</h2>
          <div className="billpunch-footer__contact-row">
            <span className="billpunch-footer__icon billpunch-footer__icon--blue">
              <FaMapMarkerAlt aria-hidden="true" />
            </span>
            <address>
              ITHUM TOWER, B 218, Block A, Industrial Area, Sector 62, Noida,
              Uttar Pradesh 201309
            </address>
          </div>
          <div className="billpunch-footer__contact-row">
            <span className="billpunch-footer__icon billpunch-footer__icon--green">
              <FaPhoneAlt aria-hidden="true" />
            </span>
            <a href="tel:+919958854324">+91 9958854324</a>
          </div>
          <div className="billpunch-footer__contact-row">
            <span className="billpunch-footer__icon billpunch-footer__icon--purple">
              <FaRegEnvelope aria-hidden="true" />
            </span>
            <a href="mailto:support@billpunch.com">support@billpunch.com</a>
          </div>
          <div className="billpunch-footer__follow">
            <h2>Follow Us</h2>
            <div className="billpunch-footer__socials">
              {socials.map(({ name, icon: Icon, url }) => (
                <a
                  key={name}
                  className={`billpunch-footer__social billpunch-footer__social--${name.toLowerCase()}`}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`BillPunch on ${name}`}
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="billpunch-footer__bottom">
        <p>© {new Date().getFullYear()} BillPunch. All rights reserved.</p>
        <span className="billpunch-footer__country">
          <span aria-hidden="true">🇮🇳</span> India
        </span>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
